module.exports = __webpack_public_path__ + "static/img/egg_b_01.5230613.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/b/egg_b_01.png
// module id = zkrl
// module chunks = 1